import DownloadsTemplate from "./DownloadsTemplate";

export default function Policies() {
  const files = [
    {
      titleKey: "governance.policies.files.1.title",
      descKey: "governance.policies.files.1.desc",
      url: "#"
    },
    {
      titleKey: "governance.policies.files.2.title",
      descKey: "governance.policies.files.2.desc",
      url: "#"
    }
  ];

  return (
    <DownloadsTemplate
      titleKey="governance.policies.title"
      descriptionKey="governance.policies.description"
      files={files}
      seoTitleKey="governance.policies.seo.title"
      seoDescKey="governance.policies.seo.description"
      seoPath="/governance/policies"
    />
  );
}
